import { Trans } from '@lingui/macro';
import { ChevronLeft } from '@mui/icons-material';
import Link, { LinkProps } from '@mui/material/Link';

export function BackLink({ children, ...props }: LinkProps) {
  return (
    <Link color="text.secondary" variant="body2" {...props}>
      <ChevronLeft fontSize="small" />
      {children ? children : <Trans id="common.backLink">Back</Trans>}
    </Link>
  );
}
